export interface Account {
    name: string;
    iban: string;
    type?: AccountType;
    balance?: number;
    extra?: string;
    alias?: string;
    spaarpotten?: Account[];
    spaarpotId?: string;
    spaarpotIcon?: string;
    mainSpaarpot?: boolean;
}

export type AccountType = 'checkings' | 'savings' | 'investment' | 'other' | 'mortgage' | 'loan' | 'loanpart';

export enum AccountTypeIds {
    checkings = 1,
    savings = 2,
    investment = 3,
    other = 4,
    mortgage = 5,
    loan = 6,
    loanpart = 7
}
